import { cardRef, afterAnyEvent, defineGameCard, oncePerRound, } from '../authoring/index.js';
import { isLocationFullyFurnished } from './furniture_helpers.js';
const ASSAULT_STOOL_ID = 'assault_stool';
const LOCATION_FULL_KEY = '@cards/ability/assault_stool/location_filled/full';
export const AssaultStoolCard = defineGameCard({
    id: ASSAULT_STOOL_ID,
    gameplay: { type: 'UNIT', cost: 1, baseStats: { attack: 2, health: 2 } },
    presentation: {
        name: 'Штурмовая табуретка',
        description: 'Первый раз за раунд, когда её локация становится заполненной, Табуретка получает Натиск и +1 к атаке.',
        glyph: {
            colors: ['#10213A', '#A41D2E', '#C32A3E', '#583733', '#7C4939'],
            rows: [
                '....................',
                '....................',
                '....111111111111....',
                '...12222222222231...',
                '...12221222212231...',
                '...12222122123331...',
                '....142222223351....',
                '..1114444114445111..',
                '..1444444445555551..',
                '..1111441111551111..',
                '.....141....151.....',
                '.....141....151.....',
                '.....141....151.....',
                '.....141....151.....',
                '.....141....151.....',
                '.....141....151.....',
                '.....111....111.....',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef(ASSAULT_STOOL_ID)],
    abilities: [
        afterAnyEvent(oncePerRound({
            abilityId: 'location_filled',
            trigger: 'onAnyEvent',
            when: (ctx) => {
                const self = ctx.self;
                return self?.cellId !== undefined
                    && self.vars[LOCATION_FULL_KEY] !== true
                    && isLocationFullyFurnished(ctx, self.controllerId, self.cellId);
            },
            run: (ctx) => {
                const self = ctx.self;
                if (self === undefined)
                    return;
                ctx.ops.addEffect({
                    defId: AssaultStoolCard.id,
                    scope: { kind: 'unit', instanceId: self.id },
                    sourceId: self.id,
                    persistent: true,
                    vars: { attackPermission: 'ignore_summoning_delay' },
                    statMods: [{ stat: 'attack', op: 'add', value: 1 }],
                });
            },
        })),
        // A separate serialized edge detector distinguishes "became full" from
        // later unrelated events while the location merely remains full.
        afterAnyEvent((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined)
                return;
            const full = isLocationFullyFurnished(ctx, self.controllerId, self.cellId);
            if (self.vars[LOCATION_FULL_KEY] !== full)
                ctx.ops.setVar(LOCATION_FULL_KEY, full);
        }),
    ],
    ui: { mechanics: ['full_room', 'rush'] },
});
//# sourceMappingURL=assault_stool.js.map